<template>
  <section>
    <div class="columns">
      <div class="column is-12">
        <comparador-paginacion />
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div>
          <b-button
            v-if="estaAbierto"
            type="is-primary"
            icon-left="check"
            class="mr-1"
            @click="closeRecuento"
          >
            Finalizar
          </b-button>
          <b-button
            type="is-success"
            icon-left="file-excel"
            :disabled="downloading"
            class="mr-1"
            @click="exportRecuento"
          >
            Exportar
          </b-button>
          <b-button
            type="is-success"
            icon-left="file-excel"
            :disabled="downloading"
            @click="exportUbicacionesRecuento"
          >
            Ubicaciones
          </b-button>
        </div>
        <div>
          <comparador-articulos :recuento="recuento" />
        </div>
      </div>
      <div class="column is-9">
        <div class="comparador-detail-wrapper">
          <div class="comparador-spacer">
            <comparador-folio-headers />
            <comparador-folios :recuento="recuento" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns'
import { mapGetters } from 'vuex'

import ComparadorArticulos from '@/components/comparador-v2/ComparadorArticulos'
import ComparadorFolioHeaders from '@/components/comparador-v2/ComparadorFolioHeaders'
import ComparadorFolios from '@/components/comparador-v2/ComparadorFolios'
import ComparadorPaginacion from '@/components/comparador-v2/ComparadorPaginacion'
import { inventarioService } from '@/services'

export default {
  name: 'Comparador',
  components: {
    ComparadorArticulos,
    ComparadorFolios,
    ComparadorFolioHeaders,
    ComparadorPaginacion
  },
  props: {
    recuento: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      downloading: false
    }
  },
  computed: {
    ...mapGetters('comparador', ['estaAbierto'])
  },
  created() {
    this.$store.dispatch('comparador/loadInitialData', {
      recuentoId: this.recuento
    })
  },
  methods: {
    async closeRecuento() {
      await this.$store.dispatch('comparador/closeRecuento', {
        recuentoId: this.recuento
      })
      this.$router.push({
        name: 'inventario',
        params: {
          accion: 'recuentos'
        }
      })
    },
    async exportRecuento() {
      this.downloading = true
      try {
        const blob = await inventarioService.exportarRecuento(this.recuento)
        const timestamp = format(new Date(), 'yyyyMMddHHmm')
        const file = window.URL.createObjectURL(new Blob([blob.data]))
        const docUrl = document.createElement('a')
        docUrl.href = file
        docUrl.setAttribute(
          'download',
          `comparativo_recuento_${this.recuento}_${timestamp}.xlsx`
        )
        document.body.appendChild(docUrl)
        docUrl.click()
        window.URL.revokeObjectURL(docUrl.href)
        document.body.removeChild(docUrl)
      } catch (error) {
        this.procesarError(error)
      }
      this.downloading = false
    },
    async exportUbicacionesRecuento() {
      this.downloading = true
      try {
        const blob = await inventarioService.exportarUbicacionesRecuento(
          this.recuento
        )
        const timestamp = format(new Date(), 'yyyyMMddHHmm')
        const file = window.URL.createObjectURL(new Blob([blob.data]))
        const docUrl = document.createElement('a')
        docUrl.href = file
        docUrl.setAttribute(
          'download',
          `ubicaciones_recuento_${this.recuento}_${timestamp}.xlsx`
        )
        document.body.appendChild(docUrl)
        docUrl.click()
        window.URL.revokeObjectURL(docUrl.href)
        document.body.removeChild(docUrl)
      } catch (error) {
        this.procesarError(error)
      }
      this.downloading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.column {
  padding: 0.5rem;
}

.comparador-detail-wrapper {
  overflow: auto;

  .comparador-spacer {
    padding: 18px 5px;
  }
}
</style>
